"use client";

import { useAtomValue } from "jotai";
import { useTranslations, useLocale } from "next-intl";
import React, { type ReactElement, ElementType } from "react";
import {
  FeatureCard,
  FeatureCardContent,
  FeatureCardDescription,
  FeatureCardLink,
  FeatureCardTitle,
  FeatureCardImage,
} from "@/components";
import { getApplication, ICONS } from "@/services/applications";
import { siteCountAtom } from "@/store/home";
import { Badge } from "@oreme/ui";

function HomeTeaserSite(): ReactElement | null {
  const t = useTranslations("home.TeaserSite");
  const locale = useLocale();
  const application = getApplication("sites");
  const count = useAtomValue(siteCountAtom);

  if (application) {
    const Icon = ICONS[application.icon] as ElementType;
    return (
      <FeatureCard className="relative flex-1 border rounded-xl hover:bg-secondary hover:ring-1">
        <FeatureCardContent className="flex-1 mt-24 pb-20 lg:pb-8">
          <FeatureCardTitle className="flex flex-col">
            {application.title[locale]}
          </FeatureCardTitle>
          {application.definition ? (
            <FeatureCardDescription className="lg:w-2/3 opacity-80">
              {application.definition[locale]}
            </FeatureCardDescription>
          ) : null}
          <Badge className="border-0 mt-auto mr-auto">
            {t("counter", { count: count || 0 })}
          </Badge>
        </FeatureCardContent>
        <FeatureCardImage className="items-start justify-start p-6">
          <Icon size={80} strokeWidth={0.2} />
        </FeatureCardImage>
        <FeatureCardLink href={application.url} />
      </FeatureCard>
    );
  }

  return null;
}

export { HomeTeaserSite };
